module.exports = __webpack_public_path__ + "static/media/skistar.aa210708.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/skistar.svg
// module id = 100
// module chunks = 3